import SMenu from './menu'
import './index.less'
export default SMenu
